// frontend/src/features/analysis/utils/smoothing.ts

const DAY_MS = 24 * 60 * 60 * 1000;

export const SMOOTHING_WINDOWS = ['off', '1d', '3d', '7d', '14d', '30d'] as const;
export type SmoothingWindow = (typeof SMOOTHING_WINDOWS)[number];

/** Default window applied when the user enables smoothing from "off". */
export const DEFAULT_SMOOTHING_WINDOW: SmoothingWindow = '7d';

const WINDOW_MS: Record<Exclude<SmoothingWindow, 'off'>, number> = {
  '1d': 1 * DAY_MS,
  '3d': 3 * DAY_MS,
  '7d': 7 * DAY_MS,
  '14d': 14 * DAY_MS,
  '30d': 30 * DAY_MS,
};

/** Returns window length in ms, or null when smoothing is off. */
export function smoothingWindowToMs(window: SmoothingWindow): number | null {
  return window === 'off' ? null : WINDOW_MS[window];
}

export function isSmoothingWindow(value: string): value is SmoothingWindow {
  return (SMOOTHING_WINDOWS as readonly string[]).includes(value);
}

/** Options for the smoothing Select (inline on desktop, in the popover on mobile). */
export const SMOOTHING_OPTIONS: { value: SmoothingWindow; label: string }[] = [
  { value: 'off', label: 'Off' },
  { value: '1d', label: '1 day' },
  { value: '3d', label: '3 days' },
  { value: '7d', label: '7 days' },
  { value: '14d', label: '14 days' },
  { value: '30d', label: '30 days' },
];
